import * as THREE from 'three';
import { disposeObject } from './helpers/ObjectHelpers';
import { buildWindow } from './window/WindowBuilder';
import { resetMullionId } from './window/WindowHelpers';

const margin = 0.2;

export class Facade {
  constructor(imageEngine, parent) {
    this.imageEngine = imageEngine;
    this.parent = parent;
    this.windows = undefined;
    this.width = undefined;
    this.height = undefined;
    this.depth = undefined;
    this.def = undefined;
    this.obj = undefined;
    this.selectedMeasurementWindow = undefined;
    this.allMeasurementsShown = false;
  }

  loadJson(json) {
    resetMullionId();
    this.clear();

    this.def = json;
    this.windows = [];
    this.allMeasurementsShown = false;
    this.obj = new THREE.Object3D();

    if (json.Facade) {
      if (Object.prototype.toString.call(json.Facade) !== '[object Array]') {
        throw 'Facade must be an array';
      }

      for (var i = 0; i < json.Facade.length; i++) {
        var win = buildWindow(this.imageEngine, this, json.Facade[i]);
        win.id = i + 1;
        this.windows.push(win);
        this.obj.add(win.obj);
      }
    } else {
      var win = buildWindow(this.imageEngine, this, json);
      win.id = 1;
      this.windows.push(win);
      this.obj.add(win.obj);
    }

    this.repositionWindows();

    this.parent.add(this.obj);

    //this.rebuild();
  }

  rebuild() {
    if (this.imageEngine) {
      if (this.imageEngine.interactionHandler) {
        var selectedIds = this.imageEngine.interactionHandler.getSelectedIds();
      }
      if (this.imageEngine.inputHandler) {
        this.imageEngine.inputHandler.saveAndCloseInputs();
      }
      if (this.imageEngine.interactionHandler) {
        this.imageEngine.interactionHandler.reset();
      }
    }

    resetMullionId();
    if (this.obj) {
      this.parent.remove(this.obj);
      disposeObject(this.obj);
    }

    for (const win of this.windows) {
      win.rebuild();
    }

    this.obj = new THREE.Object3D();
    this.repositionWindows();
    this.parent.add(this.obj);

    if (this.imageEngine) {
      this.imageEngine.scene.updateMatrixWorld();
      if (this.imageEngine.interactionHandler) {
        this.imageEngine.interactionHandler.selectObjectsByIds(selectedIds);
      }
      this.imageEngine.requireRenderUpdate = true;
    }
  }

  repositionWindows() {
    this.width = 0;
    this.height = 0;
    this.depth = 0;

    for (var i = 0; i < this.windows.length; i++) {
      if (i !== 0) {
        this.width += margin;
      }
      var win = this.windows[i];

      if (this.windows.length > 1 && win.measurement) {
        this.width += win.measurement.width;
      }
      win.obj.position.x = this.width;

      this.width += win.width;
      this.height = Math.max(this.height, win.height);
      this.depth = Math.max(this.depth, win.breadth);

      this.obj.add(win.obj);
    }
  }

  clear() {
    if (this.obj) {
      this.parent.remove(this.obj);
      disposeObject(this.obj);
    }
    this.obj = undefined;
    this.windows = undefined;
    this.width = undefined;
    this.height = undefined;
    this.detph = undefined;
    this.def = undefined;
  }

  update(deltaTime) {
    var needsUpdate = false;
    for (var i = 0; i < this.windows.length; i++) {
      needsUpdate |= this.windows[i].update(deltaTime);
    }
    return needsUpdate;
  }

  toggleMeasurement(win) {
    if (this.selectedMeasurementWindow === win) {
      win = undefined;
    }
    this.measureWindow(win);
    this.rebuild();
  }

  unmeasureCurrentWindow() {
    if (this.imageEngine) {
      this.imageEngine.requireRenderUpdate = true;
    }

    if (this.selectedMeasurementWindow) {
      this.selectedMeasurementWindow.removeMeasurement();
      this.selectedMeasurementWindow = undefined;
    }
  }

  measureWindow(win) {
    if (this.imageEngine) {
      this.imageEngine.requireRenderUpdate = true;
    }

    this.unmeasureCurrentWindow();

    if ((!this.imageEngine || this.imageEngine.enableMeasurement) && win) {
      win.addMeasurement();
    }
    this.selectedMeasurementWindow = win;
  }

  toggleAllMeasurements() {
    for (var i = 0; i < this.windows.length; i++) {
      if (this.allMeasurementsShown) {
        this.windows[i].removeMeasurement();
      } else {
        this.windows[i].addMeasurement();
      }
    }
    this.allMeasurementsShown = !this.allMeasurementsShown;
    this.rebuild();
  }

  onCameraZoom() {
    for (const window of this.windows) {
      window.onCameraZoom();
    }
    this.repositionWindows();
  }

  onRendererResize() {
    for (const window of this.windows) {
      window.onRendererResize();
    }
    this.repositionWindows();
  }
}
